import React from 'react';
import PropTypes from 'prop-types';

const RoleIndicator = ({ hasRole }) => {
    if (hasRole) {
        return <span className="role-indicator role-has" title="Has role">✓</span>;
    }
    return <span className="role-indicator role-none" title="Does not have role">–</span>;
};

RoleIndicator.propTypes = {
    hasRole: PropTypes.bool.isRequired
};

export default RoleIndicator;
